module.exports = __webpack_public_path__ + "static/media/vhs.c6f6345c.svg";